<template>
	<div class="flag-grid mb-3">
		<div
				v-for="flag in flagButtons"
				:key="flag.key"
				class="flag-item"
				@click="toggleFlag(flag)"
		>
			<img
					:src="hasFlag(flag.value) ? flag.activeImage : flag.inactiveImage"
					:alt="flag.alt"
					width="64"
					height="64"
					:title="hasFlag(flag.value) ? flag.removeTitle : flag.addTitle"
					:style="{
          cursor: 'pointer',
          WebkitFilter: hasFlag(flag.value) ? '' : 'grayscale(1)'
        }"
			>
		</div>
	</div>
	<!-- modal Confirm Dialogue -->
	<b-modal
			v-model="modalConfirm.state"
			centered
			ok-title="Bestätigen"
			cancel-title="Abbrechen"
			:title="modalConfirm.title"
			@ok="confirmModal"
			@cancel="resetConfirmModal"
			@hidden="resetConfirmModal"
	>
		<p class="mb-0">{{ modalConfirm.message }}</p>
	</b-modal>
</template>

<script>
export default {
	name: "FlagSection",
	props: {
		passedProduct: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			product: this.passedProduct,
			modalConfirm: {
				state: false,
				title: 'Bitte bestätigen',
				message: '',
				onConfirm: null,
			},
			modalError:
					{
						show: false,
						title: 'Speichern',
						message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.',
						error: '',
					},
			FSK_18: 1,
			DHL_KLEINPAKET: 2,            //Sendungsart
			VINYL: 4,
			BULKY_GOOD: 8,
			POWER_PLUG: 16,
			VENDOR_WEIGHT_AMBIGUOUS: 32,
			VENDOR_WEIGHT_WELTRECORDS: 64,
			LIQUID: 128,
			AMIIBO: 256,            //Versandaufschlag
			SKYLANDERS: 512,
			FUNKO: 1024,
			SPRING_PARCEL_US: 2048,
			CALENDAR: 4096,
			PARROT: 8192,
			NINTENDO_GAME: 16384,
			LITHIUM_BATTERY: 32768,
			MANUAL_PACKAGE_DIMENSIONS: 65536,
			POST_NL_LETTERBOX_PLUS:131072,
			CLAIREFONTAINE: 262144,
			TPLINK: 524288,
			MOLESKINE: 1048576,
			NETGEAR: 2097152,
			PALADONE: 4194304,
			OVERSIZED_SPRING: 8388608,
      CATEGORY_MANUALLY_SET: 16777216,
			FRAGILE: 33554432,
			DP_LETTER: 67108864,
			DP_WARENPOST_DE: 134217728,
			DP_WARENPOST_INT: 268435456,
			SPRING_LETTER: 536870912,
			SPRING_BOXABLE: 1073741824,
			SHIPPING_WEIGHT_TYPE_MARKET: 0,
			SHIPPING_WEIGHT_TYPE_VENDOR: 1,
			SHIPPING_WEIGHT_TYPE_DEFAULT:2,
			SHIPPING_WEIGHT_TYPE_MANUAL: 3,
		}
	},
	computed: {
		flagButtons() {
			return [
				{
					key: 'fsk18',
					value: this.FSK_18,
					activeImage: '/images/FSK18_small.png',
					inactiveImage: '/images/FSK18_small.png',
					alt: 'FSK 18',
					addTitle: 'FSK 18-Markierung setzen',
					removeTitle: 'FSK 18-Markierung entfernen',
					addConfirm: 'Wollen Sie das Material als FSK 18 markieren?',
					removeConfirm: 'Wollen Sie die FSK 18 Markierung entfernen?',
				},
				{
					key: 'lithium',
					value: this.LITHIUM_BATTERY,
					activeImage: '/images/battery_red.png',
					inactiveImage: '/images/battery_gray.png',
					alt: 'Batterie',
					addTitle: 'Lithium Batterie erlauben',
					removeTitle: 'Lithium Batterie verbieten',
					addConfirm: 'Wollen Sie die Batterie Markierung hinzufügen?',
					removeConfirm: 'Wollen Sie die Batterie Markierung entfernen?',
				},
				{
					key: 'vinyl',
					value: this.VINYL,
					activeImage: '/images/vinyl-icon.png',
					inactiveImage: '/images/vinyl-icon-grey.png',
					alt: 'Vinyl',
					addTitle: 'als Vinyl markieren',
					removeTitle: 'Vinyl-Markierung entfernen',
					addConfirm: 'Wollen Sie die Vinyl Markierung hinzufügen?',
					removeConfirm: 'Wollen Sie die Vinyl Markierung entfernen?',
				},
				{
					key: 'powerPlug',
					value: this.POWER_PLUG,
					activeImage: '/images/powerplug-red.png',
					inactiveImage: '/images/powerplug-gray.png',
					alt: 'Netzstecker',
					addTitle: 'Netzstecker-Markierung setzen',
					removeTitle: 'Netzstecker-Markierung entfernen',
					addConfirm: 'Wollen Sie eine Stromstecker-Markierung hinzufügen?',
					removeConfirm: 'Wollen Sie die Stromstecker-Markierung entfernen?',
				},
				{
					key: 'liquid',
					value: this.LIQUID,
					activeImage: '/images/liquid-red.png',
					inactiveImage: '/images/liquid-gray.png',
					alt: 'Flüssigkeit',
					addTitle: 'Flüssigkeits-Markierung setzen',
					removeTitle: 'Flüssigkeits-Markierung entfernen',
					addConfirm: 'Wollen Sie die Flüssigkeits-Markierung hinzufügen?',
					removeConfirm: 'Wollen Sie die Flüssigkeits-Markierung entfernen?',
				},
			];
		},
	},
	methods: {
		save()
		{
			//this.product.materialCategory = this.passedMaterialCategory;
			this.product.manualUpdateOverride = true;
			axios.put('/mds/product', this.product)
					.then( response => {
						this.product = response.data;
						this.formatReleaseDate();
					}).catch( error => {
				this.modalError = {
					show: true,
					title: 'Speichern',
					message: "Der Speichervorgang konnte aufgrund eines serverseitigen Fehlers nicht ausgeführt werden.",
					error: error.toString()
				};
				this.product.setManualWeightUpdateUser = '0';
				axios.get(`/mds/product/${this.product.asin}`).then( response => {
					this.product = response.data;
				}).catch( error => console.log(error) );
			});
		},
		hasFlag(flagValue) {
			return (this.product.flags & flagValue) === flagValue;
		},

		toggleFlag(flag) {
			const isActive = this.hasFlag(flag.value);

			this.openConfirmModal(
					isActive ? flag.removeConfirm : flag.addConfirm,
					() => {
						if (isActive) {
							this.product.flags &= ~flag.value;
						} else {
							this.product.flags |= flag.value;
						}

						this.product.flagOverrides |= flag.value;
						this.save();
					}
			);
		},

		openConfirmModal(message, onConfirm) {
			this.modalConfirm.state = true;
			this.modalConfirm.message = message;
			this.modalConfirm.onConfirm = onConfirm;
		},

		confirmModal() {
			if (typeof this.modalConfirm.onConfirm === 'function') {
				this.modalConfirm.onConfirm();
			}

			this.resetConfirmModal();
		},

		resetConfirmModal() {
			this.modalConfirm.state = false;
			this.modalConfirm.message = '';
			this.modalConfirm.onConfirm = null;
		},
	}
}
</script>

<style scoped>
.flag-grid {
	display: flex;
	flex-wrap: wrap;
	gap: .5rem;
	align-items: center;
}

.flag-item {
	width: 64px;
	height: 64px;
}
</style>